module.exports = __webpack_public_path__ + "img/Capture7.1483b6d5.jpg";